import type { CommunityDetail } from '@pba/react-network';
import { ContentWrapper } from 'ui';
import { CommunityAssetsContent } from './community-assets-content';

type P = {
  community: CommunityDetail;
};

const CommunityAssets = ({ community }: P) => (
  <ContentWrapper>
    <CommunityAssetsContent community={community} />
  </ContentWrapper>
);

export default CommunityAssets;
